import type { ITextReplaceRule } from '@carboncopyco/types';
import React from 'react';

export const TextReplaceFormContext = React.createContext<{
  advancedSettings?: ITextReplaceRule['options'];
  setAdvancedSettings?: (image: ITextReplaceRule['options']) => void;
}>({});
